exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsection[data-v-fdb6c252]{\n  padding: 50px 0;\n}\nsection.header-section[data-v-fdb6c252]{\n  padding: 0 !important;\n}\n.breadcrumb-section[data-v-fdb6c252]{\n  margin-bottom: 0 !important;\n  padding: 30px 0;\n}\n.categories-top-row[data-v-fdb6c252]{\n  margin-top: -6.5%;\n}\n\n", ""]);

// exports
